import { GetProject } from '@/connection/projects/get-project';
import { serializeError, getPayloadMessage, SerializedError } from '@/store/utils/serialize-error';
import { ProjectStateReducerCreator } from '../types';
import { RootState } from '@/store/root-state';

const loadPreviewTemplateReducer = (create: ProjectStateReducerCreator) => {
  return create.asyncThunk(
    async (
      { uuid, returnStoreStateIfExists }: { uuid: string; returnStoreStateIfExists?: boolean },
      { rejectWithValue, getState }
    ) => {
      try {
        if (returnStoreStateIfExists) {
          const state = getState() as RootState;
          const proj = state.project?.workingProject;
          if (proj && proj.uuid === uuid) {
            return proj;
          }
        }
        const result = await GetProject(uuid);
        if (!result) {
          return rejectWithValue('Error loading project');
        }
        if ('error' in result) {
          console.error('loadProject error', result.error);
          return rejectWithValue(serializeError(result.error));
        }
        return result;
      } catch (e) {
        return rejectWithValue(serializeError(e));
      }
    },
    {
      fulfilled: (state, action) => {
        if (action.payload) {
          state.previewTemplate = action.payload;
        }
        state.loadingPreviewTemplate = false;
      },
      pending: (state) => {
        state.loadingPreviewTemplate = true;
      },
      rejected: (state, action) => {
        console.error(action.payload || action.error);
        state.loadingPreviewTemplateError =
          getPayloadMessage(action.payload as SerializedError | string | undefined) ||
          action.error?.message ||
          'Error loading project';
        state.loadingPreviewTemplate = false;
      },
    }
  );
};

export default loadPreviewTemplateReducer;
